<template>
  <div style="backgrounded-color: #f2f2f2; height: 100vh">
    <div
      style="
        backgrounded-color: #f2f2f2;
        display: grid;
        grid-template-rows: 1fr;
        align-items: center;
        justify-items: center;
      "
    >
      <span style="font-size: 100px; color: #999999; font-size: 14rem; font-weight: 600">500</span>
      <v-icon style="font-size: 5rem; color: #fec72f">mdi-tools</v-icon>
      <span style="font-weight: 600; color: black">{{ errorTitle }}</span>
      <span>{{ errorMessage }}</span>
      <span v-if="!isOAuthError">Please try again later.</span>
      <span>
        <a :href="ulcPartnerFlag ? 'https://ulc.asu.edu/contact-us/' : 'https://ea.asu.edu/contact/'" target="_blank">
          contact our support team</a
        >
        for assistance.
      </span>
      <span v-if="referenceId">Error Code: {{ referenceId }}</span>
      <router-link to="/dashboard" style="margin-top: 10px">
        <v-btn style="backgrounded-color: #fec627" rounded v-if="loginch">
          Back to Dashboard
          <v-icon style="padding-left: 5px">mdi-arrow-right</v-icon>
        </v-btn>
        <v-btn style="backgrounded-color: #fec627" rounded v-else>
          Back to Home
          <v-icon style="padding-left: 5px">mdi-arrow-right</v-icon>
        </v-btn>
      </router-link>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

import { AjaxLoader } from '../mixins/ajaxLoader';
import { Helper } from '../mixins/helpers';

export default defineComponent({
  name: 'ServerError',
  data() {
    return {};
  },

  mixins: [Helper, AjaxLoader],

  props: {
    referenceId: {
      type: String
    }
  },

  computed: {
    loginch: function () {
      return this.$auth.isAuthenticated();
    },
    ulcPartnerFlag() {
      return Helper.methods.isUlcPartner();
    },
    isOAuthError() {
      return this.$route.query.type === 'oauth';
    },
    errorTitle() {
      return this.isOAuthError ? this.$route.query.error : 'Internal Server Error';
    },
    errorMessage() {
      return this.isOAuthError
        ? this.$route.query.message
        : 'Sorry, Earned Admission is experiencing some technical problems.';
    }
  },

  mounted() {}
});
</script>
